import { render, staticRenderFns } from "./SecretarioNotas.vue?vue&type=template&id=049811fc&"
import script from "./SecretarioNotas.vue?vue&type=script&lang=js&"
export * from "./SecretarioNotas.vue?vue&type=script&lang=js&"
import style0 from "./SecretarioNotas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports